<template>
  <BModal
    id="booking-form"
    :hide-header-close="false"
    :no-close-on-backdrop="false"
    :no-close-on-esc="true"
    :hide-footer="true"
    :title="title"
    size="xl"
    @hidden="onHidden"
  >
    <BookingForm
      v-if="loadBookingForm"
      :id="selectedBooking"
      :init-data="initData"
      @cancelled="close"
      @saved="onSaved"
      @deleted="onDeleted"
      @booking-cancelled="onBookingCancelled"
      @loaded="onLoaded"
    />
  </BModal>
</template>

<script>
export default {
  name: 'BookingFormModal',

  components: {
    BookingForm: () => import('./Form.vue'),
  },

  data() {
    return {
      loadBookingForm: false,
      selectedBooking: null,
      initData: null,
      bookingNumber: null,
    }
  },

  computed: {
    title() {
      if (this.selectedBooking) {
        if (this.bookingNumber) {
          return `#${this.bookingNumber}`
        }

        return this.$t('general.loading')
      }

      return this.$t('bookings.create')
    },
  },

  methods: {
    show(bookingId = null, initData = null) {
      this.selectedBooking = bookingId
      this.initData = initData
      this.loadBookingForm = true
      this.$bvModal.show('booking-form')
    },

    close() {
      this.$bvModal.hide('booking-form')
    },

    onSaved(data) {
      this.$emit('saved', data)
      this.close()
    },

    onDeleted(data) {
      this.$emit('deleted', data)
      this.close()
    },

    onBookingCancelled(data) {
      this.$emit('booking-cancelled', data)
      this.close()
    },

    onHidden() {
      this.loadBookingForm = false
      this.selectedBooking = null
      this.initData = null
      this.bookingNumber = null
    },

    onLoaded(data) {
      this.bookingNumber = data.number
    },
  },
}
</script>
